var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "@irati/ui/src/Flex";
import { H2 } from "@irati/ui/src/Headings";
import { minWidthMedia } from "@irati/ui/src/global/media";
var BANNER_HEIGHT = "236px";
export var Background = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  height: ", ";\n  margin-bottom: ", ";\n  padding: 40px 0;\n"], ["\n  background-color: ", ";\n  height: ", ";\n  margin-bottom: ", ";\n  padding: 40px 0;\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.perkbox.blue;
}, BANNER_HEIGHT, function (_a) {
    var theme = _a.theme;
    return theme.spacing.three;
});
export var ExtendedBackground = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-size: cover;\n  background-color: ", ";\n  height: ", ";\n  position: relative;\n"], ["\n  background-size: cover;\n  background-color: ", ";\n  height: ", ";\n  position: relative;\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.perkbox.blue;
}, BANNER_HEIGHT);
export var DashboardHeading = styled(H2)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: none;\n  color: ", ";\n  min-width: 200px;\n  align-self: baseline;\n  flex-shrink: 2;\n  ", "\n"], ["\n  display: none;\n  color: ", ";\n  min-width: 200px;\n  align-self: baseline;\n  flex-shrink: 2;\n  ",
    "\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.greys.white;
}, minWidthMedia.desktop(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: initial;\n  "], ["\n    display: initial;\n  "]))));
export var FlexGrow = styled(Flex)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex-grow: 0.63;\n"], ["\n  flex-grow: 0.63;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
